import throttle from 'lodash/throttle';
import { PluginFunction } from 'vue';
import { Vue } from 'vue-property-decorator';
import { VueConstructor } from 'vue/types/vue';

const Bus: VueConstructor = Vue.extend({
    name: 'EventBus',
});

const EventBus: Vue = new Bus();

const throttleWrap = (f: any, delay: number = 300): any => {
    return throttle(f, delay, { leading: false });
};

const onWindowResize = throttleWrap(() => {
    const orientation: string = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
    EventBus.$emit('windowResize', { orientation, width: window.innerWidth, height: window.innerHeight });
});
window.addEventListener('resize', onWindowResize, { passive: true });

const onOrientationChange = throttleWrap(() => {
    const orientation: string = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
    EventBus.$emit('orientationChange', { orientation });
});

window.addEventListener('orientationchange', onOrientationChange);

window.addEventListener('load', () => {
    EventBus.$emit('load');
});

window.document.addEventListener('DOMContentLoaded', () => {
    EventBus.$emit('ready');
});

const plugin: PluginFunction<any> = (v: VueConstructor): void => {
    v.prototype.$events = EventBus;
};

export { EventBus };

export default plugin;
